import React from 'react';
import { Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import logo from './../img_icons/logo.svg';

const logoStyle = {
  width: '50px',
  height: '50px',
  cursor: 'pointer',
  borderRadius: '50%',
  border: '1.5px solid #f1f1f1', // Añade esta línea
};

const Copyright = () => {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © '}
      <Link href="https://sin-web.web.app/" color='#5d0303'>Calocho Usugha&nbsp;</Link>
      {new Date().getFullYear()}
    </Typography>
  );
}

const Footer = () => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        py: { xs: 8, sm: 10 },
        backgroundImage: 'linear-gradient(180deg, #8E0505, #f9f9f9)',
        margin: 0, // Elimina cualquier margen
        padding: { xs: '20px', md: '50px' }, // Ajuste de padding para diferentes tamaños de pantalla
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: { xs: '100%', sm: '60%' },
          }}
        >
          <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
            <Box sx={{ ml: '2px' }}>
              <img
                src={logo}
                style={logoStyle}
                alt="logo de SIN"
              />
            </Box>
            <Typography variant="body2" fontWeight={600} gutterBottom color='#f9f9f9'>
                Boletín
            </Typography>
            <Typography variant="body2" color="#f9f9f9" mb={2}>
                Suscríbete a mi boletín de noticias para recibir actualizaciones y promociones semanales.
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap>
              <TextField
                id="outlined-basic"
                hiddenLabel
                size="small"
                variant="outlined"
                fullWidth
                aria-label="Enter your email address"
                placeholder="Ingresa tu dirección de correo electrónico"
                color='#f9f9f9'
                inputProps={{
                    autoComplete: 'off'
                }}
                sx={{ border: '1.5px solid #f1f1f1', color: '#f9f9f9f9' }}
              />
              <Button variant="outlined" size="small" color="#5d0303" sx={{ flexShrink: 0, border: '1.5px solid #f1f1f1', color: '#f9f9f9f9'}}>
                Subscribir
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <div>
          <Link color="text.secondary" fontWeight={400} href="#">
            Política de privacidad
          </Link>
          <Typography display="inline" fontWeight={400} sx={{ mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link color="text.secondary" fontWeight={400} href="#">
            Términos de servicio
          </Link>
          <Copyright />
        </div>
      </Box>
    </Box>
  );
}

export default Footer;